type Props = {
  message?: string;
  submessage?: string;
};

const CinematicLoader = ({ message = 'Loading', submessage = 'Please wait' }: Props) => {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-6">
      <div className="border-brand-500 h-14 w-14 animate-spin rounded-full border-4 border-t-transparent" />
      <h2 className="animate-pulse text-xl font-medium text-gray-900">
        {message}
        <span className="ml-1 inline-flex">
          <span className="animate-dot-flash">.</span>
          <span className="animate-dot-flash [animation-delay:0.3s]">.</span>
          <span className="animate-dot-flash [animation-delay:0.6s]">.</span>
        </span>
      </h2>
      {submessage && <p className="max-w-[300px] text-center text-sm text-gray-500">{submessage}</p>}
    </div>
  );
};

export default CinematicLoader;
